// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AvatarPickerController from "./avatar_picker_controller"
application.register("avatar-picker", AvatarPickerController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import ConfirmDeleteController from "./confirm_delete_controller"
application.register("confirm-delete", ConfirmDeleteController)

import FaqController from "./faq_controller"
application.register("faq", FaqController)

import LandingController from "./landing_controller"
application.register("landing", LandingController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)
